// import { useCallback, useContext, useRef, useState, useEffect } from "react";
import { Col } from "react-bootstrap";
// import web3 from "web3";

// import CongratulationsModal from "../congratulationsModal";
// import Marker from "../marker";
// import NFTViewerModal from "../nftViewerModal";

// import fieldTypes from "../../models/fieldTypes";

// import { W3Context } from "../../services/context";
// import { WHEEL_CONTRACT } from "../../services/contract";

// import tapToSpinImage from "../../assets/tap_to_spin.png";
// import WheelOfFortune from "../../assets/wheel_of_fortune_circle.png";
import WheelOfFortuneOutOfService from "../../assets/wheel_of_fortune_out_of_service.png";

import "./wheel.css";

// const TURNS_OF_WHEEL = 20;
// const DEGREES_DEFLECTION = 10;
// const DEGREES_LONG_ANIMATION = 360 + 360 * 3000;
// // Amount of degrees to sum when the marker is on the intersection between fields
// const POSITIVE_DEGREES_TO_ROTATE = DEGREES_DEFLECTION;
// // Amount of degrees to extract when the marker is on the intersection between fields
// const NEGATIVE_DEGREES_TO_ROTATE = -DEGREES_DEFLECTION;

// const SPIN_TIMES = 1;

const Wheel = (
  {
    // elements,
    // geoSpinsAmount,
    // setGeoSpinsAmount,
    // setShouldRefresh,
    // setErrorMessage,
    // displayErrorModal,
    // setDisplayErrorModal,
    // DEFAULT_ERROR_MESSAGE,
    // GAS_FEE,
  }
) => {
  // const { active, account, library } = useContext(W3Context);
  // const imgWheelOfFortune = useRef(null);
  // const [actualDegreesWithDeflection, setActualDegreesWithDeflection] =
  //   useState(0);
  // const [btnSpinDisabled, setBtnSpinDisabled] = useState(false);
  // const [displayCongratulationsModal, setDisplayCongratulationsModal] =
  //   useState(false);
  // const [displayNFTViewerModal, setDisplayNFTViewerModal] = useState(false);

  // const [fieldSelected, setFieldSelected] = useState(null);
  // const [transactionPending, setTransactionPending] = useState(false);

  // const [reward, _setReward] = useState({});

  // const setRewardRef = useRef(reward);

  // const setReward = (data) => {
  //   setRewardRef.current = data;
  //   _setReward(data);
  // };

  // const AMOUNT_OF_WHEEL_FIELDS = elements.length;
  // const DEGREES_PER_FIELD = 360 / AMOUNT_OF_WHEEL_FIELDS;

  // useEffect(() => {
  //   const sumProbabilities = elements.reduce((value, element) => {
  //     return (value += element.probability);
  //   }, 0);
  //   console.log("sumProbabilities", sumProbabilities.toFixed(4));
  //   if (sumProbabilities.toFixed(4) !== "100.0000") {
  //     throw new Error("All the probabilities must sum 100");
  //   }
  // }, [elements]);

  // const stopWheel = useCallback((degrees) => {
  //   const wheel = imgWheelOfFortune.current;
  //   console.log("Continue execution...");

  //   wheel.style.transform = `rotate(${0}deg)`;
  //   wheel.style.transition = "none";

  //   setTimeout(() => {
  //     setTransactionPending(false);
  //     wheel.style.transition = "all 5s ease-out";
  //     wheel.style.transform = `rotate(${degrees}deg)`;
  //   }, 10);
  // }, []);

  // const randomDegreesFromInterval = (minDegrees, maxDegrees) => {
  //   // Generates random number between two numbers
  //   // https://stackoverflow.com/a/7228322
  //   return Math.floor(
  //     Math.random() * (maxDegrees - minDegrees + 1) + minDegrees
  //   );
  // };

  // const setDegreesRotation = useCallback(
  //   (totalDegress, actualDegrees, lowDegreesLimit, highDegreesLimit) => {
  //     if (highDegreesLimit <= lowDegreesLimit) {
  //       setBtnSpinDisabled(false);
  //       throw new Error("High limit cannot be lower or equal to low limit");
  //     }

  //     if (
  //       actualDegrees > lowDegreesLimit &&
  //       actualDegrees <= lowDegreesLimit + DEGREES_DEFLECTION
  //     ) {
  //       stopWheel(totalDegress + POSITIVE_DEGREES_TO_ROTATE);
  //       setActualDegreesWithDeflection(
  //         actualDegrees + POSITIVE_DEGREES_TO_ROTATE
  //       );
  //     } else if (
  //       actualDegrees >= highDegreesLimit - DEGREES_DEFLECTION &&
  //       actualDegrees <= highDegreesLimit
  //     ) {
  //       stopWheel(totalDegress + NEGATIVE_DEGREES_TO_ROTATE);
  //       setActualDegreesWithDeflection(
  //         actualDegrees + NEGATIVE_DEGREES_TO_ROTATE
  //       );
  //     } else {
  //       stopWheel(totalDegress);
  //       setActualDegreesWithDeflection(actualDegrees);
  //     }
  //   },
  //   [stopWheel]
  // );

  // useEffect(() => {
  //   if (transactionPending && reward.rewardPackage) {
  //     const gettedReward = elements.find(
  //       (element) => element.rewardPackageId === parseInt(reward.rewardPackage)
  //     );

  //     setFieldSelected({
  //       ...reward,
  //       type: gettedReward.type,
  //     });

  //     const { position } = gettedReward;
  //     console.log("Position ", position);

  //     const maxDegrees = DEGREES_PER_FIELD * position;
  //     const minDegrees = DEGREES_PER_FIELD * (position - 1);

  //     let randomDegrees = randomDegreesFromInterval(minDegrees, maxDegrees);
  //     randomDegrees = randomDegrees === 0 ? 1 : randomDegrees;

  //     let totalDegrees = randomDegrees + 360 * TURNS_OF_WHEEL;
  //     setDegreesRotation(totalDegrees, randomDegrees, minDegrees, maxDegrees);
  //   }
  // }, [reward]);

  // const wheelError = (message = DEFAULT_ERROR_MESSAGE) => {
  //   setErrorMessage(message);
  //   setDisplayErrorModal(true);
  //   setTimeout(() => {
  //     stopWheel(0);
  //   }, 5000);
  // };

  // const getRandomPrize = useCallback(async () => {
  //   if (active) {
  //     const wheelContract = new library.eth.Contract(
  //       WHEEL_CONTRACT.abi,
  //       WHEEL_CONTRACT.address
  //     );

  //     const myAddress = library.utils.toChecksumAddress(account);

  //     try {
  //       await wheelContract.methods
  //         .spinWheel(myAddress, SPIN_TIMES)
  //         .send({
  //           from: myAddress,
  //           gasPrice: web3.utils.toWei(GAS_FEE, "gwei"),
  //         })
  //         .then(async (res) => {
  //           if (
  //             !res ||
  //             !res.events ||
  //             !res.events.RewardGiven ||
  //             !res.events.RewardGiven.returnValues
  //           ) {
  //             wheelError("Error: Empty transaction");
  //             return;
  //           }

  //           const { nftOwner, rewardPackage, tokenId } =
  //             res.events.RewardGiven.returnValues;

  //           if (
  //             nftOwner.toString().toLowerCase() ===
  //             account.toString().toLowerCase()
  //           ) {
  //             const nftTokenId = parseInt(tokenId);

  //             const rewardPackageId = parseInt(rewardPackage);

  //             const gettedReward = elements.find(
  //               (element) => element.rewardPackageId === rewardPackageId
  //             );

  //             if (
  //               (gettedReward.type === fieldTypes.LOCATION ||
  //                 gettedReward.type === fieldTypes.SPECIAL_LOCATION) &&
  //               nftTokenId > 0
  //             ) {
  //               try {
  //                 const response = await fetch(
  //                   `https://static.geopoly.io/nfts/${nftTokenId.toString()}.json`
  //                 );
  //                 const NFTJson = await response.json();

  //                 const { name, image, animation_url, attributes } = NFTJson;

  //                 setReward({
  //                   ...reward,
  //                   nftOwner,
  //                   tokenId: nftTokenId,
  //                   rewardPackage: rewardPackageId,
  //                   name,
  //                   image,
  //                   video: animation_url,
  //                   latitude: attributes.shift().value,
  //                   longitude: attributes.shift().value,
  //                   country: attributes.shift().value,
  //                   tier: attributes.shift().value,
  //                   category: attributes.shift().value,
  //                 });
  //               } catch (err) {
  //                 console.log(err);
  //                 wheelError("Error: error fetching data from API");
  //               }
  //             } else {
  //               setReward({
  //                 ...reward,
  //                 nftOwner,
  //                 rewardPackage: rewardPackageId,
  //                 amount: gettedReward.amount,
  //               });
  //             }
  //           }

  //           setShouldRefresh(true);
  //         })
  //         .catch((err) => {
  //           console.log(err);
  //           wheelError();
  //         });
  //     } catch (err) {
  //       console.log(err);
  //       wheelError();
  //     }
  //   }
  // }, [
  //   DEGREES_PER_FIELD,
  //   elements,
  //   setDegreesRotation,
  //   geoSpinsAmount,
  //   setGeoSpinsAmount,
  // ]);

  // const rotateWheel = useCallback(() => {
  //   const wheel = imgWheelOfFortune.current;
  //   wheel.style.transition = "all 1000s linear";
  //   wheel.style.transform = `rotate(${DEGREES_LONG_ANIMATION}deg)`;
  //   getRandomPrize();
  // }, [getRandomPrize]);

  // const onPressSpinButton = useCallback(() => {
  //   setBtnSpinDisabled(true);
  //   setTransactionPending(true);
  //   rotateWheel();
  // }, [rotateWheel]);

  // const handleImgTransitionEnd = () => {
  //   if (displayErrorModal || !fieldSelected) {
  //     return;
  //   }

  //   const wheel = imgWheelOfFortune.current;
  //   if (transactionPending) {
  //     wheel.style.transform = "none";
  //     wheel.style.transition = "none";
  //     setTimeout(() => {
  //       wheel.style.transition = "all 1000s linear";
  //       wheel.style.transform = `rotate(${DEGREES_LONG_ANIMATION}deg)`;
  //     });
  //     return;
  //   }

  //   wheel.style.transition = "none";
  //   wheel.style.transform = `rotate(${actualDegreesWithDeflection}deg)`;
  //   setBtnSpinDisabled(false);

  //   [fieldTypes.LOCATION, fieldTypes.SPECIAL_LOCATION].includes(
  //     fieldSelected.type
  //   )
  //     ? setDisplayNFTViewerModal(true)
  //     : setDisplayCongratulationsModal(true);
  // };

  // const canSpinNow = geoSpinsAmount > 0 && !btnSpinDisabled;

  return (
    <>
      {/* {fieldSelected &&
      [fieldTypes.LOCATION, fieldTypes.SPECIAL_LOCATION].includes(
        fieldSelected.type
      ) ? (
        <NFTViewerModal
          fieldSelected={fieldSelected}
          displayModal={displayNFTViewerModal}
          setDisplayModal={setDisplayNFTViewerModal}
        />
      ) : (
        <CongratulationsModal
          fieldSelected={fieldSelected}
          displayModal={displayCongratulationsModal}
          setDisplayModal={setDisplayCongratulationsModal}
        />
      )} */}
      <Col className="container-wheel text-center">
        {/* <img className="tap-to-spin" src={tapToSpinImage} alt="tap-to-spin" /> */}
        <img
          src={WheelOfFortuneOutOfService}
          // ref={imgWheelOfFortune}
          className="wheel"
          alt="wheel-of-fortune"
          // onTransitionEnd={handleImgTransitionEnd}
        />
        {/* <Marker handleBtnSpinClick={onPressSpinButton} disabled={!canSpinNow} /> */}
      </Col>
    </>
  );
};

export default Wheel;
